import { useGetFinanzeReport } from "@/lib/supabaseQueries";
import { AreaChart, Area, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer, Legend } from "recharts";
import { TrendingUp, TrendingDown } from "lucide-react";

export default function FinanzeReport() {
  const { data: report = [], isLoading } = useGetFinanzeReport();

  const totEntrate = report.reduce((a: number, r: any) => a + Number(r.entrate || 0), 0);
  const totUscite = report.reduce((a: number, r: any) => a + Number(r.uscite || 0), 0);
  const margine = totEntrate - totUscite;

  return (
    <div>
      <div className="mb-6">
        <h1 className="text-xl font-bold text-foreground">Report Finanziario</h1>
        <p className="text-sm text-muted-foreground mt-0.5">Ultimi 6 mesi</p>
      </div>

      <div className="grid grid-cols-3 gap-4 mb-6">
        <div className="bg-card rounded-xl p-4 border border-border">
          <div className="flex items-center gap-2 mb-1">
            <TrendingUp className="h-4 w-4 text-green-600" />
            <span className="text-xs text-muted-foreground">Totale entrate</span>
          </div>
          <div className="text-xl font-bold text-green-700">€{totEntrate.toLocaleString("it")}</div>
        </div>
        <div className="bg-card rounded-xl p-4 border border-border">
          <div className="flex items-center gap-2 mb-1">
            <TrendingDown className="h-4 w-4 text-red-500" />
            <span className="text-xs text-muted-foreground">Totale uscite</span>
          </div>
          <div className="text-xl font-bold text-red-600">€{totUscite.toLocaleString("it")}</div>
        </div>
        <div className="bg-card rounded-xl p-4 border border-border">
          <span className="text-xs text-muted-foreground">Margine netto</span>
          <div className={`text-xl font-bold mt-1 ${margine >= 0 ? "text-foreground" : "text-red-600"}`}>€{margine.toLocaleString("it")}</div>
        </div>
      </div>

      <div className="bg-card rounded-xl p-6 border border-border">
        <h2 className="text-sm font-semibold text-foreground mb-4 uppercase tracking-wide">Andamento mensile</h2>
        {isLoading ? (
          <div className="h-64 flex items-center justify-center text-sm text-muted-foreground">Caricamento...</div>
        ) : (
          <ResponsiveContainer width="100%" height={300}>
            <AreaChart data={report}>
              <defs>
                <linearGradient id="entrate" x1="0" y1="0" x2="0" y2="1">
                  <stop offset="5%" stopColor="#c4956a" stopOpacity={0.25} />
                  <stop offset="95%" stopColor="#c4956a" stopOpacity={0} />
                </linearGradient>
                <linearGradient id="uscite" x1="0" y1="0" x2="0" y2="1">
                  <stop offset="5%" stopColor="#e05a2b" stopOpacity={0.15} />
                  <stop offset="95%" stopColor="#e05a2b" stopOpacity={0} />
                </linearGradient>
              </defs>
              <CartesianGrid strokeDasharray="3 3" stroke="#e8e3dc" />
              <XAxis dataKey="label" tick={{ fontSize: 12, fill: "#7a756e" }} axisLine={false} tickLine={false} />
              <YAxis tick={{ fontSize: 12, fill: "#7a756e" }} axisLine={false} tickLine={false} />
              <Tooltip contentStyle={{ borderRadius: "8px", border: "1px solid #e8e3dc", fontSize: 12 }} formatter={(v: any) => `€${Number(v).toLocaleString("it")}`} />
              <Legend wrapperStyle={{ fontSize: 12 }} />
              <Area type="monotone" dataKey="entrate" stroke="#c4956a" strokeWidth={2} fill="url(#entrate)" name="Entrate" />
              <Area type="monotone" dataKey="uscite" stroke="#e05a2b" strokeWidth={2} fill="url(#uscite)" name="Uscite" />
            </AreaChart>
          </ResponsiveContainer>
        )}
      </div>
    </div>
  );
}
